import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitovapicab() {



const cardData = {
  keyword: "Mumbai to Vapi Cab",

headingDescription:
  "Omshree Cab provides reliable and comfortable Mumbai to Vapi cab services for travelers seeking a smooth and convenient journey from Maharashtra to Gujarat. Whether you are planning a business trip, family visit, weekend getaway, or group travel, our cab service ensures a safe and hassle-free ride with experienced drivers and well-maintained vehicles. We offer flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Vapi cab services.",

topPlaces: [
  {
    title: "GIDC Garden",
    description:
      "GIDC Garden in Vapi is a peaceful green space ideal for morning walks, photography, and relaxation. Visitors can enjoy landscaped gardens, seating areas, and tranquil surroundings. Traveling by cab ensures a comfortable journey from Mumbai and allows ample time to unwind and explore this local attraction."
  },
  {
    title: "Parnera Fort",
    description:
      "Parnera Fort, located near Vapi, is a historic fort offering panoramic views of the surrounding hills and valleys. Visitors can explore ancient architecture, trekking paths, and scenic viewpoints. A cab ride provides convenient access, making it easier to integrate the fort visit into a full day of sightseeing."
  },
  {
    title: "Daman Ganga Tourist Complex",
    description:
      "This tourist complex near Vapi features gardens, river views, and recreational facilities. Visitors can enjoy family outings, photography, and peaceful walks. Traveling by cab ensures hassle-free access, allowing tourists to combine natural beauty with local sightseeing comfortably."
  },
  {
    title: "Tithal Beach",
    description:
      "Tithal Beach, a short drive from Vapi, is known for its black sand, calm waves, and serene environment. Visitors can enjoy leisurely walks, local snacks, photography, and sunset views. A cab service ensures easy transport, allowing visitors to spend quality time at the beach without worrying about local commuting."
  },
  {
    title: "Jampore Beach",
    description:
      "Jampore Beach, located near Vapi in Daman, offers scenic coastline, water activities, and a relaxed atmosphere. Visitors can engage in photography, beach sports, and picnics. Traveling by cab provides convenient access, making it easy to plan multiple nearby sightseeing spots in one trip."
  },
  {
    title: "Moti Daman Fort",
    description:
      "Moti Daman Fort is a historic landmark with bastions, churches, and museums showcasing Portuguese heritage. Visitors can explore architecture, capture photographs, and enjoy the serene surroundings. A cab ride ensures comfortable travel from Mumbai, enabling a full day of sightseeing."
  },
  {
    title: "St. Jerome Fort",
    description:
      "St. Jerome Fort is another historical attraction near Vapi with scenic views and rich heritage. Visitors can explore fort structures, take photographs, and enjoy peaceful walks. Traveling by cab ensures hassle-free transport, allowing tourists to include multiple heritage sites in their itinerary."
  },
  {
    title: "Daman Market",
    description:
      "Daman Market is vibrant with local handicrafts, souvenirs, and regional snacks. Visitors can shop, explore culture, and enjoy street food delicacies. A cab ride provides convenient transport, allowing travelers to combine shopping with sightseeing efficiently."
  },
  {
    title: "Gopika Temple",
    description:
      "Gopika Temple near Vapi is a spiritual site attracting devotees and visitors interested in cultural exploration. Travelers can perform rituals, enjoy peaceful surroundings, and capture photographs. Traveling by cab ensures easy access and comfortable transport for a spiritual experience."
  },
  {
    title: "Local Parks & Recreation Areas",
    description:
      "Vapi has several parks and recreation areas suitable for family outings, photography, and relaxation. Visitors can enjoy open spaces and leisure activities. A cab service provides hassle-free travel from Mumbai, enabling tourists to cover multiple attractions efficiently."
  }
],




services: [
{
name: "Mumbai to Vapi Cab",
description: "Mumbai to Vapi cab service offers comfortable and reliable intercity travel between Mumbai and the industrial city of Vapi in Gujarat. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth highway journeys along NH-48. Professional drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, railway stations, and Mumbai airport terminals. Ideal for business travelers, corporate employees, and family trips. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip options allow convenient trip planning. Transparent pricing ensures a smooth and stress-free cab booking experience."
},
{
name: "Mumbai to Vapi Taxi",
description: "Mumbai to Vapi taxi service provides convenient road transportation for passengers traveling between Maharashtra and Gujarat. Comfortable AC vehicles ensure pleasant long-distance travel across well-connected highways. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, industrial visits, and family journeys. Clean interiors and spacious seating ensure comfortable travel. Flexible departure schedules allow passengers to plan trips conveniently. Reliable taxi services ensure safe and smooth intercity travel."
},
{
name: "Mumbai to Vapi Cab Service",
description: "Mumbai to Vapi cab service offers dependable transportation for travelers visiting the major industrial hub of Vapi. Our well-maintained AC vehicles ensure comfortable highway travel and smooth journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from residential areas, offices, hotels, and airport terminals across Mumbai. Ideal for corporate visits, factory travel, and business meetings. Spacious interiors provide comfortable seating for long-distance journeys. Flexible booking options allow travelers to schedule trips easily. Transparent pricing ensures reliable cab service."
},
{
name: "Mumbai to Vapi Taxi Service",
description: "Mumbai to Vapi taxi service offers efficient road transportation for passengers traveling to Gujarat’s important industrial destination. Our fleet includes AC sedans and SUVs suitable for long-distance highway travel. Skilled drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, industrial visits, and personal trips. Spacious seating ensures comfort throughout the journey. Flexible scheduling allows convenient travel planning. Affordable fares ensure smooth taxi travel."
},
{
name: "Cab from Mumbai to Vapi",
description: "Cab from Mumbai to Vapi offers private and comfortable transportation for passengers traveling between the two cities. Our AC vehicles ensure smooth and relaxed highway journeys throughout the trip. Professional drivers ensure safe driving and reliable travel services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travelers, families, and corporate groups. Spacious interiors ensure comfortable seating during long-distance journeys. Flexible departure timing allows convenient trip planning. Reliable cab services ensure stress-free travel."
},
{
name: "Taxi from Mumbai to Vapi",
description: "Taxi from Mumbai to Vapi provides dependable road transportation for passengers traveling to the industrial hub of Gujarat. Comfortable AC vehicles ensure pleasant travel conditions along the highway route. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travelers and corporate employees. Clean interiors and spacious seating ensure passenger comfort. Flexible scheduling options allow easy trip planning. Professional taxi services ensure reliable intercity travel."
},
{
name: "Mumbai to Vapi Cab Booking",
description: "Mumbai to Vapi cab booking allows travelers to easily reserve vehicles for intercity travel. Online and phone booking options provide quick confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel, corporate visits, and family trips. Flexible one-way and round-trip booking options are available. Reliable booking services ensure hassle-free travel planning."
},
{
name: "Mumbai to Vapi Taxi Booking Online",
description: "Mumbai to Vapi taxi booking online provides fast and convenient reservations for travelers planning business or personal trips. Instant booking confirmation allows passengers to schedule trips easily. Comfortable AC vehicles ensure relaxed highway travel conditions. Experienced drivers ensure safe and professional driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travelers and families. Flexible travel timing allows convenient scheduling. Reliable online booking ensures smooth taxi reservations."
},
{
name: "Mumbai to Vapi Cab Price",
description: "Mumbai to Vapi cab price offers transparent and affordable travel options for passengers planning intercity journeys. Clear pricing details allow travelers to understand total trip costs before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for various travel needs. Comfortable seating and AC interiors ensure relaxed travel throughout the journey. Professional drivers ensure safe highway travel and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai to Vapi Taxi Fare",
description: "Mumbai to Vapi taxi fare is calculated using transparent per-kilometer pricing to ensure clear travel costs. Passengers can choose vehicles based on comfort and budget preferences. Our AC vehicles ensure smooth highway travel between Mumbai and Vapi. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business trips and family travel. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Vapi One Way Cab",
description: "Mumbai to Vapi one way cab service is perfect for travelers who need a drop service without paying return charges. This option helps reduce travel costs while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for long-distance highway journeys. Professional drivers ensure safe driving and punctual arrival. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel and personal trips. Flexible departure timing allows convenient scheduling. Reliable one-way cab service ensures affordable travel."
}
],

tableData: [
["Mumbai to Vapi Cab","Mumbai to Vapi Taxi"],
["Mumbai to Vapi Cab Service","Mumbai to Vapi Taxi Service"],
["Cab from Mumbai to Vapi","Taxi from Mumbai to Vapi"],
["Mumbai to Vapi Cab Booking","Mumbai to Vapi Taxi Booking Online"],
["Mumbai to Vapi Cab Price","Mumbai to Vapi Taxi Fare"],
["Mumbai to Vapi One Way Cab","Best Cab Mumbai to Vapi"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with the Mumbai to Vapi highway route via NH48. They understand traffic patterns, toll routes, and the fastest highway stretches between Maharashtra and Gujarat, ensuring a smooth and safe journey."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai to Vapi cab bookings. We clearly explain per-kilometer fares, toll charges, and travel packages before confirming the trip so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to travel early morning, late night, or during business hours, Omshree Cabs provides 24/7 cab booking and customer support for your Mumbai to Vapi journey."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized to ensure a comfortable ride for long-distance travel."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible travel plans including one-way cabs, round-trip bookings, and same-day return options for Mumbai to Vapi travel."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for business travelers, families, and group trips."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and airports anywhere in Mumbai so your journey to Vapi starts smoothly without any hassle."
  },
  {
    WhyChooseheading: "Reliable Intercity Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by travelers for Mumbai to Vapi cab services. Our punctual drivers, professional service, and comfortable vehicles ensure a smooth and reliable travel experience."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Vapi by cab?", answer: "The distance from Mumbai to Vapi is approximately 170 km and the journey usually takes around 3–4 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Vapi cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Vapi." },
  { question: "Which vehicles are available for Mumbai to Vapi travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport or any location in Mumbai for Vapi cab bookings." },
  { question: "Can we stop during the journey for meals or rest?", answer: "Yes, passengers can request stops during the journey for refreshments or short breaks." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you provide same-day return trips?", answer: "Yes, same-day return cab packages from Mumbai to Vapi are available." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak travel hours and weekends." },
  { question: "Do you provide corporate travel services to Vapi?", answer: "Yes, Omshree Cabs provides corporate cab services for business travelers commuting between Mumbai and Vapi." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harsh Patel",
    feedback:
      "Booked Omshree Cabs for my Mumbai to Vapi business trip. The driver was punctual and the car was very clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anita Desai",
    feedback:
      "Our Mumbai to Vapi family trip with Omshree Cabs was excellent. Smooth driving, clear pricing, and professional service made the journey stress-free.",
    rating: 5
  }
];






















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Vapi Cab",
  "description": "Book Mumbai to Vapi Cab with Omshree Cab for safe and comfortable outstation travel. Reliable taxi service from Mumbai to Vapi with options for one-way trips. Affordable fares, easy online cab booking, and trusted cab service for your Vapi journey.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1900"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Mumbai to Vapi Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Vapi Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Vapi with one-way options. Affordable fares and easy online cab booking for your Vapi trip." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitovapicab;